import {ref, computed} from "vue"
import {defineStore, acceptHMRUpdate} from "pinia"
import {firestore} from "@/firebase/index.js"
import {collection, query, where} from "firebase/firestore"
import {useShopStore} from "./shop"

export const useShopRidesStore = defineStore("shopRides", () => {
  // stores
  const shopStore = useShopStore()

  // state
  const rides = ref([])
  const status = ref("init")
  const unsubscribe = ref(null)

  // getters
  const shopRidesLoaded = computed(() => status.value == "loaded")

  // actions
  async function bind() {
    const shopId = shopStore.shopId
    const collectionRef = collection(firestore, `shops/${shopId}/rides`)
    const q = query(collectionRef, where("state", "!=", "done"))
    return await this.attach("rides", q)
  }

  async function unbind() {
    return await this.detach()
  }

  return {
    // state
    rides,
    status,
    unsubscribe,

    // getters
    shopRidesLoaded,

    // actions
    bind,
    unbind,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useShopRidesStore, import.meta.hot))
}
